import React from 'react';
import 'react-quill/dist/quill.snow.css';

function MainWindow(props) {
   
    return (
        <>
        <div style={{position: 'relative', width: `${props.width}px`, height: '100%', overflow: 'auto', display: 'flex', flexDirection: 'column', 
            borderBottom: '1px solid var(--aixelo-gray)',
            borderRight: '1px solid var(--aixelo-gray)',
            borderLeft: '1px solid var(--aixelo-gray)'}}>
            {props.children}
        </div>
    </>
    );
   
}

export default MainWindow;